export default __webpack_public_path__ + "static/media/logo-text.7a58cda2.png";